// TODO: remove this tmp fix
export function decodeHtml(text: string): string {
  if (!text) {
    return text;
  }
  return text.replace(/(&#(\d+);)/g, (match, capture, charCode) => String.fromCharCode(charCode));
}
